import { render, staticRenderFns } from "./TarefaStatus.vue?vue&type=template&id=8dd7cf76&"
import script from "./TarefaStatus.vue?vue&type=script&lang=js&"
export * from "./TarefaStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports